import React from 'react';
import { TransportSearchContextInterface } from '../../types/TransportSearchContextTypes';

// Create a context with no initial values.
export const TransportSearchContext = React.createContext<TransportSearchContextInterface | null>(null);

export default TransportSearchContext;
